import React, { useState } from 'react';
import { StyleSheet, View, ScrollView, Text, Linking } from 'react-native';
import NavigateRow from '../../NavigateRow';
import ExpandableContent from './ExpandableContent';
import Unorderedlist from 'react-native-unordered-list';
import BaseText from '../../BaseText';
import { CommonStyles, Color } from '../../../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../../i18n';
import { companyEmails, companyLinks } from '../../../constants/Enums';
const PrivacyModal = () => {
  const { tKey } = useComponentTKey('PrivacyModal');
  const { t } = useTranslation(i18nNS.settings);
  const [infoViewerVisible, setInfoViewerVisible] = useState(false);
  const [changesPolicyViewerVisible, setchangesPolicyViewerVisible] = useState(false);
  const [whoWeAreViewerVisible, setwhoWeAreViewerVisible] = useState(false);
  const [useOfInfoVisible, setUseOfInfoViewerVisible] = useState(false);
  const [cookiesViewerVisible, setCookieViewerVisible] = useState(false);
  const [securityViewerVisible, setSecurityViewerVisible] = useState(false);
  const [nonItsViewerVisible, setNonItsViewerVisible] = useState(false);
  const [globalViewerVisible, setGlobalViewerVisible] = useState(false);
  const [disclosureViewerVisible, setDisclosureViewerVisibleVisible] = useState(false);
  const [mergersViewerVisible, setMergerViewerVisible] = useState(false);
  const [changesViewerVisible, setChangesViewerVisible] = useState(false);
  const [conatactViewerVisible, setConatactViewerVisible] = useState(false);

  const onChangesPolicyPress = () => {
    setchangesPolicyViewerVisible(!changesPolicyViewerVisible);
  };
  const onWhoWeArePress = () => {
    setwhoWeAreViewerVisible(!whoWeAreViewerVisible);
  };
  const onInfoPress = () => {
    setInfoViewerVisible(!infoViewerVisible);
  };
  const onUseOfInfoPress = () => {
    setUseOfInfoViewerVisible(!useOfInfoVisible);
  };
  const onCookiePress = () => {
    setCookieViewerVisible(!cookiesViewerVisible);
  };
  const onSecurityPress = () => {
    setSecurityViewerVisible(!securityViewerVisible);
  };
  const onNonItsPress = () => {
    setNonItsViewerVisible(!nonItsViewerVisible);
  };
  const onGlobalPress = () => {
    setGlobalViewerVisible(!globalViewerVisible);
  };
  const onContactPress = () => {
    setConatactViewerVisible(!conatactViewerVisible);
  };
  const onMergerPress = () => {
    setMergerViewerVisible(!mergersViewerVisible);
  };
  const onChangesPress = () => {
    setChangesViewerVisible(!changesViewerVisible);
  };
  const onDisclosurePress = () => {
    setDisclosureViewerVisibleVisible(!disclosureViewerVisible);
  };

  return (
    <View style={CommonStyles.flex1}>
      <ScrollView>
        <NavigateRow
          text={t(tKey('ChangesToPolicyTitle'))}
          onPressCallback={onChangesPolicyPress}
        />
        {changesPolicyViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('ChangesToPolicy'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('WhoWeAreTitle'))} onPressCallback={onWhoWeArePress} />
        {whoWeAreViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('WhoWeAre'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('InformationCollectedHeading'))} onPressCallback={onInfoPress} />
        {infoViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('NonPersonalInformation'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('PersonalInformation'))}</BaseText>
            <BaseText>{t(tKey('PersonalInformationContent'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('UseOfInformation'))} onPressCallback={onUseOfInfoPress} />
        {useOfInfoVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>{t(tKey('InformationProvided'))}</BaseText>
            <Unorderedlist>
              <BaseText>{t(tKey('Inquiries'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('TravelServices'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('RegardingPurchase'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('RegardingPurchase2'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('ServicesPurchased'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('InformationAndUupdates'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('SendInvoices'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('EmailNotifications'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('EmailMessages'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('MarketingCommunications'))}</BaseText>
            </Unorderedlist>
            <BaseText style={CommonStyles.my3}>{t(tKey('InformationProvide'))}</BaseText>
            <Unorderedlist>
              <BaseText>{t(tKey('YourName'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('ContactInformation'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('ProfessionalInformation'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('PaymentAndCardNumber'))}</BaseText>
            </Unorderedlist>
            <BaseText style={CommonStyles.my3}>{t(tKey('LimitTheUseOfPersonalData'))}</BaseText>
            <Unorderedlist>
              <BaseText>{t(tKey('LimitTheUseOfPersonalData1'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('LimitTheUseOfPersonalData2'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('LimitTheUseOfPersonalData3'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('LimitTheUseOfPersonalData4'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('LimitTheUseOfPersonalData5'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('LimitTheUseOfPersonalData6'))}</BaseText>
            </Unorderedlist>
            <BaseText style={CommonStyles.my3}>{t(tKey('ProvidePersonalData'))}</BaseText>
            <Unorderedlist>
              <BaseText>{t(tKey('PurchaseFromUs'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('SubmitComplaint'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('CompleteSurvey'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('SubmitAContact'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('SubscribeOurEmail'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('RegisterUserProfile'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('ContactByOtherMeans'))}</BaseText>
            </Unorderedlist>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('InformationColletecAutomatically'))}
            </BaseText>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('InformationColletecAutomatically2'))}
            </BaseText>
            <Unorderedlist>
              <BaseText>{t(tKey('InformationColletecAutomatically3'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('InformationColletecAutomatically4'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('InformationColletecAutomatically5'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('InformationColletecAutomatically6'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('InformationColletecAutomatically7'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('InformationColletecAutomatically8'))}</BaseText>
            </Unorderedlist>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('PersonallyIdentifiableInformation'))}
            </BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('TransferYourInfo'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('ShareYourInfo'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('RightToUseData'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('DataIsNotShared'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('NotResponsibleForThirdParty'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('OptionToOptOut'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('UseOfCookies'))} onPressCallback={onCookiePress} />
        {cookiesViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>{t(tKey('DataCollection'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('CollectionOfInfo'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('Security'))} onPressCallback={onSecurityPress} />
        {securityViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('SecurityMeasures'))}
              <BaseTextEmail email={companyEmails.protectionOfficer} />.
            </BaseText>
            <BaseText style={styles.boldText}>{t(tKey('SecurityMeasures2'))}</BaseText>
            <BaseText>{t(tKey('SecurityMeasures3'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('NonItsWebsites'))} onPressCallback={onNonItsPress} />
        {nonItsViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('LinksToOtherWebsite'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('GlobalOrganisation'))} onPressCallback={onGlobalPress} />
        {globalViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('GlobalOrganisationWithBusiness'))}
            </BaseText>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('MemberOfEuropeanUnion'))}
              <BaseTextEmail email={companyEmails.privacyOfficer} />
              {t(tKey('MemberofEuropeanUnion2'))}
            </BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('RepresentativeInUE'))} </BaseText>
            <BaseText>
              <BaseTextEmail email={companyEmails.gdpRepresentative} />
              {t(tKey('EUUKContactinfo1'))}
              <BaseTextEmail email={companyEmails.privayrep} />
            </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo2'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo3'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo4'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo5'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo6'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo7'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo8'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo9'))} </BaseText>
            <BaseText>{t(tKey('EUUKContactinfo10'))} </BaseText>
            <BaseText style={CommonStyles.my3}>
              {t(tKey('UnresolvedPrivacyShield'))}
              <Hyperlink word={companyLinks.reportFraud} link={companyLinks.reportFraud} />
              {t(tKey('UnresolvedPrivacyShield'))}
            </BaseText>
            <BaseText>{t(tKey('CompliantNotResolved'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('Disclosure'))} onPressCallback={onDisclosurePress} />
        {disclosureViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('GovernmentOrders'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('MergersHeading'))} onPressCallback={onMergerPress} />
        {mergersViewerVisible && (
          <ExpandableContent>
            <BaseText>{t(tKey('MergeBusiness'))}</BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('UserRightsHeading'))} onPressCallback={onChangesPress} />
        {changesViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>{t(tKey('UserRightPolicy'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('UserRightPolicy2'))}</BaseText>
            <Unorderedlist>
              <BaseText>
                {t(tKey('UserRightPolicy3'))}
                <BaseTextEmail email={companyEmails.privacy} />.
              </BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('UserRightPolicy4'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('UserRightPolicy5'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('UserRightPolicy6'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('UserRightPolicy7'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('UserRightPolicy8'))}</BaseText>
            </Unorderedlist>
            <Unorderedlist>
              <BaseText>{t(tKey('UserRightPolicy9'))}</BaseText>
            </Unorderedlist>
            <BaseText style={CommonStyles.my3}>{t(tKey('UserRightPolicy10'))}</BaseText>
            <BaseText style={[CommonStyles.my3, styles.boldText]}>
              {t(tKey('UserRightPolicy11'))}
            </BaseText>
            <BaseText>
              {t(tKey('UserRightPolicy12'))}
              <Hyperlink word="Click here" link={companyLinks.contactDataProtection} />.
              {t(tKey('UserRightPolicy13'))}
            </BaseText>
          </ExpandableContent>
        )}
        <NavigateRow text={t(tKey('ConatctInformation'))} onPressCallback={onContactPress} />
        {conatactViewerVisible && (
          <ExpandableContent>
            <BaseText style={CommonStyles.my3}>{t(tKey('ConatctPrivacyOfficer'))}</BaseText>
            <BaseText>{t(tKey('PrivacyOfficer'))}</BaseText>
            <BaseText>{t(tKey('ContactByPhone'))}</BaseText>
            <BaseText>
              {t(tKey('EmailAt'))}
              <BaseTextEmail email={companyEmails.protectionOfficerLC} />
              {t(tKey('EmailAt2'))}
            </BaseText>
            <BaseText>{t(tKey('MailAt'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('RespondYourInquiries'))}</BaseText>
            <BaseText style={CommonStyles.my3}>{t(tKey('MaintainedByIts'))}</BaseText>
          </ExpandableContent>
        )}
        <BaseText style={styles.fotter}>{t(tKey('Fotter'))}</BaseText>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  fotter: {
    textAlign: 'center',
  },
  bulletPointContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  bulletPoint: {
    marginRight: 10,
    marginLeft: 10,
  },
  boldText: {
    fontWeight: 'bold',
  },
  link: {
    color: Color.primary,
  },
});

const BaseTextEmail = ({ email }) => {
  return (
    <BaseText onPress={() => Linking.openURL('mailto:' + email)} style={styles.link}>
      {email}
    </BaseText>
  );
};

const Hyperlink = ({ word, link }) => {
  const handlePress = () => {
    Linking.openURL(link);
  };
  return (
    <Text onPress={handlePress} style={styles.link}>
      {word}
    </Text>
  );
};

export default PrivacyModal;
